export const commonStyles = {
  tableRecordsFoundTitleStyle: {
    color: "var(--color-im-grey-900)"
  }
};
